import { Storno } from '~/features/common/Balance/BalanceHistory/Storno'
import { priceFormat } from '~/shared/lib/utils'
import {
  AsyncGridColumns,
  ColumnAmount,
  ColumnDate,
  ColumnLink,
  ColumnValue,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const useColumns = (gridQueryKey: string): AsyncGridColumns<GridRow> => {
  return [
    {
      headerName: 'column.operation date',
      field: 'appliedAt',
      minWidth: 160,
      renderCell: ({ row }) => (
        <ColumnLink to={row.id}>
          <ColumnDate type='date' value={row.appliedAt} />
        </ColumnLink>
      ),
    },
    {
      headerName: 'column.operation time',
      field: 'appliedAtTime',
      sortable: false,
      minWidth: 150,
      renderCell: ({ row }) => <ColumnDate type='time' value={row.appliedAt} />,
    },
    {
      headerName: 'column.income',
      field: 'coming-{amount}',
      minWidth: 160,
      renderCell: ({ value }) => (
        <ColumnAmount moveFunds='COMING' amount={value} />
      ),
    },
    {
      headerName: 'column.expense',
      field: 'expenditure-{amount}',
      minWidth: 160,
      renderCell: ({ value }) => (
        <ColumnAmount moveFunds='SPENDING' amount={value} />
      ),
    },
    {
      headerName: 'column.residue',
      field: 'balanceAmount',
      minWidth: 180,
      renderCell: ({ value }) =>
        value && <ColumnValue>{priceFormat(value)}</ColumnValue>,
    },
    {
      headerName: 'column.turnover item',
      field: 'flowStatementName',
      minWidth: 260,
    },
    {
      headerName: 'column.description',
      field: 'comment',
      flex: 1,
    },
    {
      headerName: 'column.user or source',
      field: 'sourceType',
      minWidth: 220,
    },
    {
      headerName: 'column.actions',
      field: 'actions',
      sortable: false,
      minWidth: 60,
      renderCell: ({ row }) =>
        !row.stornoId && (
          <Storno isIcon transactionId={row.id} gridQueryKey={gridQueryKey} />
        ),
    },
  ]
}
